import { useCallback, useEffect, useRef, useState } from 'react'

import { InvoiceNode, useAllInvoicesQuery } from '@/apollo/graphql'
import { getFetchMoreStatus } from '@/utils'
import { IPageInfo } from '@/types'

const pageSize = 15

const initialPageInfo: IPageInfo = {
  hasNextPage: false,
  offset: 0,
  fetchMoreStatus: 'loading',
}

export const useSelect = (customerId?: number) => {
  const prevKeyword = useRef<string>('')
  const [search, setSearch] = useState<string>('')
  const [proposals, setProposals] = useState<Partial<InvoiceNode>[]>([])
  const [pageInfo, setPageInfo] = useState<IPageInfo>(initialPageInfo)

  const { loading, networkStatus } = useAllInvoicesQuery({
    fetchPolicy: 'network-only',
    variables: {
      offset: pageInfo?.offset || 0,
      first: pageSize,
      text: search,
      customer: customerId,
    },
    onCompleted: res => {
      if (res.allInvoices?.edges) {
        const _proposals: Partial<InvoiceNode>[] = []
        res.allInvoices.edges.forEach(e => {
          // @ts-ignore
          if (e?.node) _proposals.push(e.node)
        })

        setProposals(prev => [...prev, ..._proposals])
        setPageInfo(prev => ({
          ...prev,
          hasNextPage: res.allInvoices?.pageInfo.hasNextPage,
          fetchMoreStatus: getFetchMoreStatus({
            networkStatus,
            hasNextPage: res.allInvoices?.pageInfo.hasNextPage,
            withForce: true,
          }),
        }))
      }
    },
  })

  const onFetchMore = useCallback(() => {
    console.log('fetches more')
    setPageInfo(prev => ({ ...prev, offset: proposals.length }))
  }, [proposals?.length])

  const onSearch = useCallback((text: string) => {
    if (prevKeyword.current !== text) {
      setProposals([])
      prevKeyword.current = text
    }
    setSearch(text)
    setPageInfo(initialPageInfo)
  }, [])

  return {
    loading,
    onSearch,
    pageInfo,
    onFetchMore,
    data: proposals,
  }
}
